import React from 'react';
import { Switch } from 'react-router';
import { Config } from '@leverege/plugin';
import { Content } from '@leverege/ui-elements';
import { TitleBar, Toolbar } from '@leverege/ui-plugin';
import { Routes } from "../../routes/index.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default class SideNavScreen extends React.Component {
  render() {
    const {
      title,
      icon,
      matchContext,
      context,
      client,
      redirectUrl,
      routeKey,
      routeMatch,
      variant = 'sideNav',
      toolbarVariant = 'sideNavBar',
      extraProps
    } = this.props;
    const redirect = redirectUrl || Config.get(client, 'redirectUrl');
    return /*#__PURE__*/_jsxs(Content, {
      variant: "rootEditor",
      horizontal: true,
      children: [/*#__PURE__*/_jsx(Content.Header, {
        variant: "rootEditorHeader",
        children: /*#__PURE__*/_jsx(TitleBar, {
          variant: variant,
          title: title,
          icon: icon,
          vertical: true,
          children: /*#__PURE__*/_jsx(Toolbar, {
            variant: toolbarVariant,
            vertical: true,
            matchContext: matchContext,
            context: context
          })
        })
      }), /*#__PURE__*/_jsx(Content.Area, {
        children: /*#__PURE__*/_jsx(Switch, {
          children: Routes.getRoutesFor(routeKey, null, routeMatch, extraProps, redirect)
        })
      })]
    });
  }
}